<a role="button" tabindex="0" aria-haspopup="menu" [attr.aria-expanded]="flagMenu.visible"
   [attr.aria-label]="label || ('common.button.user_language' | translate)"
   (keydown.enter)="flagMenu.toggle($event)" (keydown.space)="$event.preventDefault(); flagMenu.toggle($event)"
   (click)="flagMenu.toggle($event)" class="flex align-items-center {{classList}}">
  <span #flagBtn class="p-button-icon flag" aria-hidden="true"></span>
  <span *ngIf="showCurrentLanguageLabel" class="language-dropdown-button__current-label">
    {{ getCurrentLanguageTranslationKey() | translate }}
  </span>
  <span [ngClass]="{'ml-3': !!label}">{{label}}</span>
</a>
<p-tieredMenu #flagMenu [model]="items" [popup]="true" appendTo="body" styleClass="language-dropdown-menu"></p-tieredMenu>
